<ez-main-layout [landingpageConfig]="landingpageConfig" [theme]="Themes.NONE">
  <ez-banner>
    <span ngProjectAs="title">Ihre Zuzahlung</span>
    <span ngProjectAs="subtitle">Jetzt bequem und direkt zuzahlen</span>
  </ez-banner>

  <div class="sepa-detail-container">
    <button id="back-top-button" (click)="onBackToOverview()">
      <img alt="left arrow icon" height="80%" src="assets/icons/left-arrow.svg" />
      <span class="text--bold"> Zurück</span>
    </button>

    <p>
      {{ landingpageConfig.organisation.customFields['insuranceInfoText'] | handlebars: landingpageConfig }}
    </p>

    <h3>SEPA-Lastschrift für {{ landingpageConfig.organisation.name }} einrichten</h3>

    <ez-fee-info-box
      [firstName]="landingpageConfig.customer.firstName"
      [lastName]="landingpageConfig.customer.lastName"
      [amountInEuro]="paymentAmount"
      [customerNumber]="landingpageConfig.customer.customerNumber"
    ></ez-fee-info-box>

    <ez-sepa-input-box
      (backToOverview)="onBackToOverview()"
      [sepaFormGroup]="form"
      [creditorId]="landingpageConfig.organisation.customFields['creditorId']"
      [organisationName]="landingpageConfig.organisation.name"
      (submitForm)="onSubmit()"
    >
    </ez-sepa-input-box>

    <ez-contact
      [organisation]="landingpageConfig.organisation"
      teaserShort="Sie möchten noch Fragen mit uns klären?"
      phonePrefix="Rufen Sie uns gerne an: "
      subtitle="Kundenservice"
      withContactForm="false"
    ></ez-contact>
  </div>
</ez-main-layout>
